import { render, staticRenderFns } from "./builder.vue?vue&type=template&id=258edd14&"
import script from "./builder.vue?vue&type=script&lang=js&"
export * from "./builder.vue?vue&type=script&lang=js&"
import style0 from "./builder.vue?vue&type=style&index=0&id=258edd14&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports